import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/JitaGuest/logo.png';
import _imports_1 from './img/JitaGuest/figure.png';
const _hoisted_1 = {
  class: "success-case"
};
const _hoisted_2 = {
  class: "success-case-banner"
};
const _hoisted_3 = {
  class: "case-info"
};
const _hoisted_4 = {
  class: "case-name"
};
const _hoisted_5 = {
  class: "tit"
};
const _hoisted_6 = {
  class: "case-title"
};
const _hoisted_7 = {
  class: "case-title"
};
const _hoisted_8 = {
  class: "desc"
};
const _hoisted_9 = {
  class: "doc-btn"
};
const _hoisted_10 = {
  class: "breadcrumb-box"
};
const _hoisted_11 = {
  class: "page-title"
};
const _hoisted_12 = {
  class: "thema-desc"
};
const _hoisted_13 = {
  class: "thema-desc"
};
const _hoisted_14 = {
  class: "thema-desc"
};
const _hoisted_15 = {
  class: "thema-desc"
};
const _hoisted_16 = {
  class: "bottom-banner"
};
const _hoisted_17 = {
  class: "banner-con"
};
const _hoisted_18 = {
  class: "title"
};
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'JitaGuest',
  setup(__props) {
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0
      }, null, -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('successCase.text92')), 1)]), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('successCase.text93')), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('successCase.text94')), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('successCase.text95')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('successCase.text96')), 1)])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
          to: {
            path: '/successCase'
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text75')), 1)]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('successCase.text97')), 1)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('successCase.text9')), 1), _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('successCase.text98')), 1), _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('successCase.text99')), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "thema-figure"
      }, [_createElementVNode("img", {
        class: "thema-img",
        src: _imports_1
      })], -1)), _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('successCase.text100')), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('successCase.text101')), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('successCase.text17')), 1), _createElementVNode("span", {
        class: "consult-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('successCase.text18')), 1)])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)]);
    };
  }
});